module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_16"
  }, [_vm._v("To my family. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_16"
  }, [_vm._v("Although it isn’t perfect, it’s mine"), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v(".  ")])]), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14",
    attrs: {
      "id": "calibre_pb_5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-609b19e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_005.vue
// module id = 72
// module chunks = 0